import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { BulkImportReportState } from "./types";

const initialState: BulkImportReportState = {};

/**
 * Which import the report modal is showing (DEV-1215).
 *
 * In Redux rather than in the component that raises the snackbar, because the two have different
 * lifetimes. The snackbar is a react-hot-toast toast — global, and set to wait for a dismissal rather
 * than expire — while `BulkImportTracker` lives inside the Book a Trip button. For an operator that
 * button is only on the Bookings page, so navigating away unmounts the tracker while its toast stays
 * on screen. A modal owned by the tracker simply could not open when that toast's View was pressed.
 *
 * Holding it here lets the modal be mounted once per portal layout, where it outlives any page.
 */
export const bulkImportReportSlice = createSlice({
  name: "bulkImportReport",
  initialState,
  reducers: {
    openBulkImportReport: (_state, { payload }: PayloadAction<BulkImportReportState>) => payload,
    closeBulkImportReport: () => initialState,
  },
});

export const { openBulkImportReport, closeBulkImportReport } = bulkImportReportSlice.actions;

export default bulkImportReportSlice.reducer;
